<div class="nav">
    <p>Dashboard</p>
    <div nav>
        <span link (click)="goHome()">Home</span><span>&nbsp;> &nbsp;</span>
        <span>Admin &nbsp;> &nbsp;</span>
        <span>{{parent.location}}</span>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/nav/hub.nav.component.html